/* eslint-disable max-len */
export default {
    title: 'About us',
    subtitle: 'Lemlock was founded as a response to increased demand for providing cyber-secured software solutions.',
    values: {
        title: 'Values'
    },
    mission_vision: {
        mission: {
            title: 'Mission',
            text: 'Making sure that our clients\' systems and solutions are secure while having both legal and technical aspects in mind.'
        },
        vision: {
            title: 'Vision',
            text: 'Lemlock wants to become the missing link between legal procedures and technical surveillance creating full synergy for the benefit of our clients.'
        },
        verified: {
            text: 'Verified by Lemlock'
        }
    },
    perspectives: {
        title: 'Meet us',
        list: [{
            image: 'bartlomiej',
            icon: 'hacker',
            occupation: '<span class="bold">Hacker’s perspective</span><br/> Chief Security Officer',
            name: 'Bartłomiej Balcerek',
            linkedin: 'https://www.linkedin.com/in/bartlomiej-balcerek-4b229a1/'
        }, {
            image: 'grzegorz',
            icon: 'developer',
            occupation: '<span class="bold">Software engineer’s perspective</span><br/> System architect',
            name: 'Grzegorz Mąkosa',
            linkedin: 'https://www.linkedin.com/in/grzegorzmakosa/'
        }, {
            image: 'marcin',
            icon: 'developer',
            occupation: '<span class="bold">Software engineer’s perspective</span><br/> System architect',
            name: 'Marcin Michalski',
            linkedin: 'https://www.linkedin.com/in/marcin-michalski-0053016/'
        }]
    },
    team: {
        title: 'Team',
        subtitle: 'The Lemlock team is made up of security testers, lawyers and software engineers.',
        text: [
            'Their experience and competences in the field of cybersecurity are confirmed by numerous projects, scientific publications and presentations at domestic and international conferences  such as Secure Poland, Computer Networks - Poland or MMM-ACNS Russia.',
            'Practical knowledge of security issues is also evidenced by finding a number of vulnerabilities in commonly used software e.g.: <a href="https://cve.mitre.org/cgi-bin/cvename.cgi?name=CVE-2013-1086" target="_blank" rel="noopener noreferrer">CVE-2013-1086</a>, <a href="https://cve.mitre.org/cgi-bin/cvename.cgi?name=CVE-2013-1087" target="_blank" rel="noopener noreferrer">CVE-2013-1087</a>, <a href="https://cve.mitre.org/cgi-bin/cvename.cgi?name=CVE-2015-2802" target="_blank" rel="noopener noreferrer">CVE-2015-2802</a>. Each activity is guided by the idea of developing a business in a responsible manner and raising awareness of existing threats in online and offline space.'
        ]
    },
    clutch: {
        title: 'They already trusted us'
    }
};



// WEBPACK FOOTER //
// ./src/i18n/en/about.js